import { AiApiClient } from '@datacamp/ai-api-integration';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { Chat } from '../Chat';
import { ConversationContext } from '../conversationContext';
import { SimulatedChat } from '../SimulatedChat';
import { jsx as ___EmotionJSX } from "@emotion/react";
const queryClient = new QueryClient();
const SelfContainedChat = _ref => {
  let {
    assistantId,
    config,
    customGptTitle,
    dataTrackIdExerciseTypePrefix,
    enableExternalChatGPT = false,
    hideResetButton = false,
    iconUrl,
    onTakeSolution,
    poweredBy,
    prompts,
    setExternalResetChatCb,
    solutionConversations,
    solutionShown,
    systemPrompt,
    userAvatarUrl
  } = _ref;
  return ___EmotionJSX(QueryClientProvider, {
    client: queryClient
  }, ___EmotionJSX(ConversationContext.Provider, {
    value: {
      aiApiClient: new AiApiClient(config.aiApiUrl),
      exerciseId: config.exerciseId,
      modelTag: config.modelTag,
      solutionConversations,
      solutionShown
    }
  }, enableExternalChatGPT && ___EmotionJSX(Chat, {
    assistantId: assistantId,
    customGptTitle: customGptTitle,
    dataTrackIdExerciseTypePrefix: dataTrackIdExerciseTypePrefix,
    hideResetButton: hideResetButton,
    iconUrl: iconUrl,
    onTakeSolution: onTakeSolution,
    poweredBy: poweredBy,
    setExternalResetChatCb: setExternalResetChatCb,
    systemPrompt: systemPrompt,
    userAvatarUrl: userAvatarUrl,
    useSimulator: !enableExternalChatGPT
  }), !enableExternalChatGPT && ___EmotionJSX(SimulatedChat, {
    dataTrackIdExerciseTypePrefix: dataTrackIdExerciseTypePrefix,
    iconUrl: iconUrl,
    prompts: prompts,
    setExternalResetChatCb: setExternalResetChatCb,
    userAvatarUrl: userAvatarUrl
  })));
};
export default SelfContainedChat;